import React from "react";
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";


class AccountDetailHeader extends React.Component {
    render() {
        return(
            <Stack>
                <Typography level={'h4'}>
                    {this.props.account.ownership?.nameshort} «{this.props.account.nameshort}»
                </Typography>
            </Stack>
        )
    }
}

export default AccountDetailHeader